<template>
  <div class="h-100">
    <div class="dp02 py-3 mt-3">
      <div class="col-lg-12">
        <b-button type="submit"
                  class="myButton"
                  @click="$router.go(-1)"
                  style="float:left">
          {{ $t('common.Back') }}
        </b-button>
        <b-button class="myButton"
                  @click="reanalysing = false; $refs.reanalyseModal.show();"
                  style="float:right"
                  v-if="!isArchived && !isInDoctorSection">
          <font-awesome-icon class="fa-md"
                             icon="diagnoses" />
          {{ $t('common.Reanalyse') }}
        </b-button>
      </div>
      <div class="text-center row col-lg-12 mb-3">
        <div class="col-4 offset-4">
          <h2>{{ $t('entities.Product.Singular') }} {{ customerName }}</h2>
        </div>
      </div>
      <div class="col-12"
           v-if="isArchived">
        <v-alert
          outlined
          type="warning"
          border="top">
          Prohlížíte archivované výsledky
        </v-alert>
      </div>
      <div class="w-100"
           v-if="!ready">
        <div class="text-center my-2 w-100">
          <b-spinner class="align-middle" />
          <strong>{{ $t("DataTable.Loading") }}...</strong>
        </div>
      </div>
      <div class="col-12 px-4"
           v-else>
        <div class="row">
          <div class="col-12 dp02 text-center">
            <div class="row">
              <div class="row my-3 col-lg-4 text-left">
                <div class="col-lg-3">
                  <label for="gender">{{ $t('fields.status') }}:</label>
                </div>
                <div class="col-lg-9">
                  <ProductStatusInput :editable="false"
                                      v-model="status" />
                </div>
              </div>
              <div class="row col-lg-4 my-3 text-left">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.generatedAt') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="generatedAtFormatted" />
                </div>
              </div>
              <div class="row col-lg-4 my-3 text-left">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.doctor') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="doctor" />
                </div>
              </div>
              <div class="row col-lg-4 my-3 text-left"
                   v-if="status === 3">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.publishedAt') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="publishedAtFormatted" />
                </div>
              </div>
              <div v-if="lastChangeAt !== null"
                   class="row col-lg-4 my-3 text-left">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.lastChangeAt') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="lastChangeAtFormatted" />
                </div>
              </div>
              <div v-if="doctorsIntroLastChange !== null"
                   class="row col-lg-4 my-3 text-left">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.doctorsIntroLastChange') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="doctorsIntroLastChangeFormatted" />
                </div>
              </div>
              <div class="row col-lg-4 my-3 text-left">
                <div class="col-lg-3">
                  <label for="productType">{{ $t('fields.productTypeId') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="productType" />
                </div>
              </div>

              <div v-if="doctorIntroReproductiveGeneticsEnabled" class="row col-lg-4 my-3 text-left">
                <div class="col-lg-3">
                  <label for="partner">{{ $t('fields.assignedCustomer') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-button variant="outline-info"
                            @click="$router.push({ name: 'admin.customers.edit', params: { id:partnerId } });">
                    {{ partner }}
                  </b-button>
                </div>
              </div>

            </div>
          </div>
          <div class="col-6 mt-2 dp02 text-center">
            <b-card no-body>
              <b-tabs card justified>
                <b-tab>
                  <template #title>
                    <h3>
                      {{ $t('EditProduct.DoctorIntro') }}
                      <span v-if="doctorIntroChanged"
                            class="text-danger">
                        <font-awesome-icon class="fa-xs"
                                           icon="save" />
                      </span>
                    </h3>
                  </template>
                  <ckeditor v-model="doctorIntro"
                            :editor="editor"
                            @ready="onReady"
                            :disabled="isArchived"
                            style="height:80vh"
                            :config="editorConfig" />
                </b-tab>
                <b-tab v-if="doctorIntroReproductiveGeneticsEnabled">
                  <template #title>
                    <h3>
                      {{ $t('EditProduct.ReproductiveGenetics') }}
                      <span v-if="doctorIntroReproductiveGeneticsChanged"
                            class="text-danger">
                        <font-awesome-icon class="fa-xs"
                                           icon="save" />
                      </span>
                    </h3>
                  </template>
                  <ckeditor v-model="doctorIntroReproductiveGenetics"
                            :editor="editor"
                            @ready="onReady"
                            :disabled="isArchived"
                            style="height:80vh"
                            :config="editorConfig" />
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
          <div class="col-6 mt-2 dp02 result-edit">
            <h3 class="text-center">
              {{ $t('entities.Product.Singular') }}
            </h3>
            <ProductDisplay :product="product" />

            <div v-if="!isArchived"
                 class="text-center col-6 offset-6 dp02 p-2 mt-3">
              <b-button
                block
                class="myButton align-middle"
                type="submit"
                @click="submit(1)">
                {{ $t('EditProduct.EditSave') }}
              </b-button>
              <b-button
                v-if="status === 1 && !customerUnderage"
                block
                class="myButton align-middle"
                type="submit"
                @click="submit(2)">
                {{ $t('EditProduct.EditUnpublished') }}
              </b-button>
              <b-button
                v-if="status === 1 && customerUnderage"
                block
                class="myButton align-middle"
                type="submit"
                @click="submit(2)">
                {{ $t('EditProduct.EditUnpublishedUnderage') }}
              </b-button>
              <p
                v-if="status === 1 && customerUnderage"
                class="text-center"
                style="color:red">
                {{ $t('common.CustomerUnderage') }}
              </p>
              <b-button
                v-if="isInDoctorSection && status === 1 || status === 2"
                block
                class="myButton align-middle"
                type="submit"
                @click="submit(4)">
                {{ $t('EditProduct.EditPrePublish') }}
              </b-button>
              <b-button
                v-if="isInDoctorSection && status === 1 || status === 2 || status === 4 || status === 5"
                block
                class="myButton align-middle"
                type="submit"
                @click="submit(3)">
                {{ $t('EditProduct.EditPublish') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-center"
             ref="reanalyseModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.ReanalyseResults') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center"
         v-if="!reanalysing">
        {{ $t('common.RealyReanalyseResultsQuestion') }}
      </p>
      <p class="my-4 text-center"
         v-else>
        {{ $t('common.ReanalysingResultsInProgress') }}
      </p>
      <div id="nprogressReanalyse"
           style="height:25px" />
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="$refs.reanalyseModal.hide();"
          v-if="!reanalysing">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="danger"
          @click="reanalyseResults();"
          v-if="!reanalysing">
          {{ $t('common.Reanalyse') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import ProductDisplay from '@components/admin/products/ProductDisplay';
import ProductStatusInput from '@components/input/ProductStatusInput';
import DecoupledEditor from '@ckeditor/ckeditor5-editor-decoupled/src/decouplededitor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import UploadAdapterPlugin from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import AutoformatPlugin from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import FontFamilyPlugin from '@ckeditor/ckeditor5-font/src/fontfamily';
import FontSizePlugin from '@ckeditor/ckeditor5-font/src/fontsize';
import FontColorPlugin from '@ckeditor/ckeditor5-font/src/fontcolor';
import FontBackgroundColorPlugin from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline';
import StrikethroughPlugin from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment';
import ListPlugin from '@ckeditor/ckeditor5-list/src/list';
import IndentPlugin from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlockPlugin from '@ckeditor/ckeditor5-indent/src/indentblock';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import BlockQuotePlugin from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import EasyImagePlugin from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import ImagePlugin from '@ckeditor/ckeditor5-image/src/image';
import ImageCaptionPlugin from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStylePlugin from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbarPlugin from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUploadPlugin from '@ckeditor/ckeditor5-image/src/imageupload';
import TablePlugin from '@ckeditor/ckeditor5-table/src/table';
import TableToolbarPlugin from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import MediaEmbedPlugin from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import HorizontalLinePlugin from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
import Adapter from '@utils/base64uploadadapter';
import NProgress from 'nprogress/nprogress';

export default {
  name: 'EditSample',
  components: {
    ProductStatusInput,
    ProductDisplay
  },
  data() {
    return {
      editor: DecoupledEditor,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          AutoformatPlugin,
          HeadingPlugin,
          FontFamilyPlugin,
          FontSizePlugin,
          FontColorPlugin,
          FontBackgroundColorPlugin,
          BoldPlugin,
          ItalicPlugin,
          UnderlinePlugin,
          StrikethroughPlugin,
          AlignmentPlugin,
          ListPlugin,
          IndentPlugin,
          IndentBlockPlugin,
          LinkPlugin,
          BlockQuotePlugin,
          ImagePlugin,
          ImageCaptionPlugin,
          ImageStylePlugin,
          ImageToolbarPlugin,
          EasyImagePlugin,
          ImageUploadPlugin,
          TablePlugin,
          TableToolbarPlugin,
          MediaEmbedPlugin,
          ParagraphPlugin,
          UploadAdapterPlugin,
          HorizontalLinePlugin
        ],
        toolbar: [
          'heading',
          '|',
          'fontFamily',
          'fontSize',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          '|',
          'numberedList',
          'bulletedList',
          '|',
          'outdent',
          'indent',
          '|',
          'link',
          'blockQuote',
          'imageUpload',
          'insertTable',
          'mediaEmbed',
          '|',
          'undo',
          'redo',
          '|',
          'horizontalLine'
        ],
        fontFamily: {
          supportAllValues: true
        },
        fontSize: {
          options: [
            'tiny',
            'small',
            'default',
            'big',
            'huge'
          ]
        },
        image: {
          toolbar: [
            'imageStyle:full',
            'imageStyle:side',
            '|',
            'imageTextAlternative'
          ]
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        },
      },
      reanalysing: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    status: {
      get() {
        return this.$store.state.editProduct.status;
      },
      set(val) {
        this.setStatus(val);
      }
    },
    doctorIntro: {
      get() {
        return this.$store.state.editProduct.doctorIntro;
      },
      set(val) {
        this.setDoctorIntro(val);
      }
    },
    doctorIntroReproductiveGenetics: {
      get() {
        return this.$store.state.editProduct.doctorIntroReproductiveGenetics;
      },
      set(val) {
        this.setDoctorIntroReproductiveGenetics(val);
      }
    },
    doctorIntroChanged: {
      get() {
        return this.$store.state.editProduct.doctorIntroChanged;
      }
    },
    doctorIntroReproductiveGeneticsChanged: {
      get() {
        return this.$store.state.editProduct.doctorIntroReproductiveGeneticsChanged;
      }
    },
    isInDoctorSection: {
      get() {
        return this.$store.state.editProduct.isInDoctorSection;
      }
    },
    isArchived: {
      get() {
        return this.$store.state.editProduct.isArchived;
      }
    },
    generatedAtFormatted() {
      return this.$moment(this.generatedAt).format('DD.MM.YYYY HH:mm:ss');
    },
    publishedAtFormatted() {
      return this.$moment(this.publishedAt).format('DD.MM.YYYY HH:mm:ss');
    },
    lastChangeAtFormatted() {
      return this.$moment(this.lastChangeAt).format('DD.MM.YYYY HH:mm:ss');
    },
    doctorsIntroLastChangeFormatted() {
      return this.$moment(this.doctorsIntroLastChange).format('DD.MM.YYYY HH:mm:ss');
    },
    ...mapState('editProduct', [
      'productId',
      'customerName',
      'product',
      'publishedAt',
      'generatedAt',
      'ready',
      'lastChangeAt',
      'customerUnderage',
      'doctorsIntroLastChange',
      'doctor',
      'productType',
      'doctorIntroReproductiveGeneticsEnabled',
      'partner',
      'partnerId',
    ]),
    ...mapGetters('editProduct', [
      'localStorageDoctorIntroKey',
      'localStorageDoctorIntroReproductiveGeneticsKey',
    ]),
  },
  mounted() {
    this.reload();
  },
  beforeDestroy() {
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.idleVue.isIdle
        || !this.$store.state.auth.auth.lastRefreshSuccess
        || (!this.doctorIntroChanged && !this.doctorIntroReproductiveGeneticsChanged)) {
      next();
      return;
    }
    this.$bvModal.msgBoxConfirm('Máte neuložené změny! Opravdu chcete odejít?', {
      title: 'Lékařská zpráva',
      size: 'md',
      buttonSize: 'md',
      okVariant: 'success',
      okTitle: 'Ano (zahodit změny)',
      cancelTitle: 'Ne',
      footerClass: 'p-2',
      hideHeaderClose: true,
      centered: true,
      noCloseOnBackdrop: true,
      noCloseOnEsc: true
    })
      .then((val) => {
        if (val) {
          this.setDoctorIntroChanged(false);
          localStorage.removeItem(this.localStorageDoctorIntroKey());
          this.setDoctorIntroReproductiveGeneticsChanged(false);
          localStorage.removeItem(this.localStorageDoctorIntroReproductiveGeneticsKey());
          next();
        } else {
          next(false);
        }
      })
      .catch(() => {
        // nothing to do in case we are logging out when idle time elapsed and the message box is still shown
      });
  },
  methods: {
    ...mapMutations({
      setProductId: 'editProduct/setProductId',
      setStatus: 'editProduct/setStatus',
      setDoctorIntroChanged: 'editProduct/setDoctorIntroChanged',
      setDoctorIntroReproductiveGeneticsChanged: 'editProduct/setDoctorIntroReproductiveGeneticsChanged'
    }),
    ...mapActions({
      setDoctorIntro: 'editProduct/setDoctorIntro',
      setDoctorIntroReproductiveGenetics: 'editProduct/setDoctorIntroReproductiveGenetics',
      resetContext: 'editProduct/resetContext',
      editProduct: 'editProduct/editProduct',
      fetchProduct: 'editProduct/fetchProduct'
    }),
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
      editor.plugins.get('FileRepository').createUploadAdapter = (loader) => new Adapter(loader);
    },
    reload() {
      this.resetContext();
      this.setProductId(this.id);
      this.fetchProduct()
        .then((result) => {
          if (result) {
            this.handleLocalStorageDoctorIntro();
            this.handleLocalStorageDoctorIntroReproductiveGenetics();
          } else {
            this.$root.$bvToast.toast(this.$t('FetchProduct.FailToast.Body'), {
              title: this.$t('FetchProduct.FailToast.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          }
        });
    },
    async submit(status) {
      let confirmMessage = '';
      if (status === 1) confirmMessage = 'Opravdu si pŕejete výslední zprávu uložit?';
      else if (status === 2) confirmMessage = 'Opravdu si přejete zákazníka vyzvat ke konzultaci?';
      else if (status === 4) confirmMessage = 'Opravdu si přejete předběžně zveřejnit výsledky?';
      else confirmMessage = 'Opravdu si přejete výslední zprávu v tomto stavu zveřejnit?';
      this.$bvModal.msgBoxConfirm(confirmMessage, {
        title: 'Jste si jisti navrhovanými změnami?',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Ano',
        cancelTitle: 'Ne',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then((val) => {
          if (val) {
            this.setStatus(status === 1 ? this.status : status);
            this.editProduct().then(() => {
              this.$root.$bvToast.toast(this.$t('EditSample.SuccessToast.Body'), {
                title: this.$t('EditSample.SuccessToast.Title'),
                variant: 'success',
                toaster: 'b-toaster-top-right'
              });
            }).catch(() => {
              this.$root.$bvToast.toast(this.$t('EditSample.FailureToast.Body'), {
                title: this.$t('EditSample.FailureToast.Title'),
                variant: 'danger',
                toaster: 'b-toaster-top-right'
              });
            });
          }
        });
    },
    handleLocalStorageDoctorIntro() {
      const localDoctorsIntroJson = localStorage.getItem(this.localStorageDoctorIntroKey());

      if (localDoctorsIntroJson != null) {
        const localDoctorsIntro = JSON.parse(localDoctorsIntroJson);

        if (localDoctorsIntro.productId === Number(this.productId)
          && localDoctorsIntro.doctorIntro !== this.doctorIntro) {
          const confirmMessage = `V mezipaměti se nachází neuložený pozměněný text lékařské zprávy
            (${localDoctorsIntro.doctorIntroChange}). Chcete jej načíst?`;

          this.$bvModal.msgBoxConfirm(confirmMessage, {
            title: 'Lékařská zpráva',
            size: 'md',
            buttonSize: 'md',
            okVariant: 'success',
            okTitle: 'Ano',
            cancelTitle: 'Zahodit',
            footerClass: 'p-2',
            hideHeaderClose: true,
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true
          })
            .then((val) => {
              if (val) {
                this.setDoctorIntro(localDoctorsIntro.doctorIntro);
              }
              localStorage.removeItem(this.localStorageDoctorIntroKey());
            })
            .catch(() => {
              // nothing to do in case we are logging out when idle time elapsed and the message box is still shown
            });
        }
      }
    },
    handleLocalStorageDoctorIntroReproductiveGenetics() {
      const localDoctorsIntroJson = localStorage.getItem(this.localStorageDoctorIntroReproductiveGeneticsKey());

      if (localDoctorsIntroJson != null) {
        const localDoctorsIntro = JSON.parse(localDoctorsIntroJson);

        if (localDoctorsIntro.productId === Number(this.productId)
          && localDoctorsIntro.doctorIntro !== this.doctorIntroReproductiveGenetics) {
          const confirmMessage = `V mezipaměti se nachází neuložený pozměněný text zprávy reprodukční genetiky
            (${localDoctorsIntro.doctorIntroChange}). Chcete jej načíst?`;

          this.$bvModal.msgBoxConfirm(confirmMessage, {
            title: 'Reprodukční genetika',
            size: 'md',
            buttonSize: 'md',
            okVariant: 'success',
            okTitle: 'Ano',
            cancelTitle: 'Zahodit',
            footerClass: 'p-2',
            hideHeaderClose: true,
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true
          })
            .then((val) => {
              if (val) {
                this.setDoctorIntroReproductiveGenetics(localDoctorsIntro.doctorIntro);
              }
              localStorage.removeItem(this.localStorageDoctorIntroReproductiveGeneticsKey());
            })
            .catch(() => {
              // nothing to do in case we are logging out when idle time elapsed and the message box is still shown
            });
        }
      }
    },
    reanalyseResults() {
      this.reanalysing = true;
      NProgress.configure({ parent: '#nprogressReanalyse' });
      NProgress.start();
      this.axios.post('admin/products/reanalyse', {
        ProductId: this.productId
      }).then((response) => {
        this.$root.$bvToast.toast(this.$t('ProductResultsReanalysis.SuccessToast.Body'), {
          title: this.$t('ProductResultsReanalysis.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        if (response.status === 200) {
          this.$router.replace({ name: 'admin.products.edit', params: { id: response.data.entityId } });
          this.reload();
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('ProductResultsReanalysis.FailToast.Body'), {
          title: this.$t('ProductResultsReanalysis.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      }).finally(() => {
        this.$refs.reanalyseModal.hide();
        NProgress.configure({ parent: 'body' });
        NProgress.done();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
